import { useStore } from "../../stores/StoreContext";
import { TranscriptionService } from "../LogicServices/TranscriptionService";

export function useTranscriptionService(): TranscriptionService {
  const storeContext = useStore();
  return new TranscriptionService(storeContext);
}
